import AnalyticsActivitiesChart from './AnalyticsActivitiesChart';

export default AnalyticsActivitiesChart;
